module.exports = __webpack_public_path__ + "img/microphone.4ceb185e.svg";